import { z } from 'zod';

export const zodDeliveryNotePartySuggestionsParamsSchema = z.object({
  limit: z.number().int().min(1).max(50).optional(),
  query: z.string().trim().min(1),
});

export const zodDeliveryNotePartyMatchTypeSchema = z.enum([
  'exact',
  'fuzzy',
  'nearest',
]);

export const zodDeliveryNotePartySuggestionSchema = z.object({
  // Formatted company address to tell identically named companies apart.
  address: z.string().nullish(),
  // Absent on the empty placeholder leading a low-confidence (`nearest`)
  // result, so nothing is preselected (DNI-871).
  companyId: z.uuid().nullish(),
  // Similarity 0-100 (token-sort ratio, same scorer DNPv1 company matching uses).
  matchScore: z.number().int().min(0).max(100),
  name: z.string().nullish(),
});

export const zodDeliveryNotePartySuggestionsResponseSchema = z.object({
  data: z.array(zodDeliveryNotePartySuggestionSchema),
  // `exact`: the queried spelling is a known name or confirmed alias (treat as the answer).
  // `fuzzy`: candidates cleared the confidence bar (top one is the likely answer).
  // `nearest`: nothing cleared it — `data` leads with an empty placeholder
  // (`{ matchScore: 0 }`, no `companyId`) followed by the closest names.
  // `null`: no candidates.
  matchType: zodDeliveryNotePartyMatchTypeSchema.nullish(),
});
